export { WorkRecordRepository } from './work-record.repository';
export { WorkRecord } from './work-record.model';
export { WorkRecordMapper } from './work-record.mapper';
export { Company, CompanyId } from './company.model';
export { Department, DepartmentId } from './department.model';
export { Industry, IndustryId } from './industry.model';



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/index.ts